/* Tiny volume-limited effects for ZETOP Slither: coin-ish chimes on orb eat
   and a rush when boosting. The soundpool is tiny, locks in on (or dies on)
   the first input. */

let ac: AudioContext | null = null;

export function unlockAudio(): void {
  if (typeof AudioContext === 'undefined') return;
  if (!ac) ac = new AudioContext();
  if (ac.state === 'suspended') ac.resume().catch(() => {});
}

function tone(freq: number, dur: number, type: OscillatorType, vol: number): void {
  if (!ac) return;
  try {
    const o = ac.createOscillator();
    const g = ac.createGain();
    o.type = type;
    o.frequency.value = freq;
    g.gain.setValueAtTime(vol, ac.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + dur);
    o.connect(g).connect(ac.destination);
    o.start();
    o.stop(ac.currentTime + dur);
  } catch { /* swallow */ }
}

export function eatSound(): void {
  tone(660, 0.12, 'sine', 0.08);
  tone(880, 0.18, 'sine', 0.05);
}

export function boostSound(): void {
  tone(180, 0.35, 'sawtooth', 0.05);
  tone(320, 0.30, 'sawtooth', 0.03);
}
